export default "__VITE_ASSET__COXjQjtE__"